var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecreaseQ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 4,
    viewBox: "0 0 11 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.894875 3.064V0.683999H10.1069V3.064H0.894875Z",
    fill: "#650D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecreaseQ);
export default __webpack_public_path__ + "static/media/decreaseQ.b8fd2cd065c9985b31cf14b469a2ec77.svg";
export { ForwardRef as ReactComponent };